<template>
    <div>
        <div class="header">Informations comptables</div>

        <v-form>
            <v-row no-gutters dense>
                <v-col cols="6" class="pb-2">
                    <v-card outlined hide-details class="card">
                        <v-card-title> Régime d'imposition </v-card-title>
                        <v-card-actions>
                            <v-select-filled
                                v-model="accounting.incomeCategory"
                                hide-details
                                :items="incomeCategories"
                                item-value="id"
                                required
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                            <v-select-filled
                                v-model="accounting.taxRegime"
                                hide-details
                                :items="taxRegimes"
                                item-value="id"
                                required
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="6" class="pb-2">
                    <v-card outlined hide-details class="card">
                        <v-card-title> Type de Comptabilité </v-card-title>
                        <v-card-actions>
                            <v-select-filled
                                v-model="accounting.accountingType"
                                hide-details
                                :items="accountingType"
                                item-value="id"
                                required
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <!-- <v-row no-gutters dense v-if="offer == 4"> -->
            <!-- <v-col cols="6"> -->
            <!-- <v-card outlined hide-details class="card"> -->
            <!-- <v-card-title class="pt-2"> TVA </v-card-title> -->
            <!-- <v-card-actions> -->
            <!-- <v-select-filled -->
            <!-- label="&#xca;tes-vous assujetti à la TVA ?" -->
            <!-- v-model="accounting.payedVAT" -->
            <!-- outlined -->
            <!-- hide-details -->
            <!-- :items="payedVAT" -->
            <!-- item-value="id" -->
            <!-- required -->
            <!-- density="compact" -->
            <!-- :item-title="(item) => item.name" -->
            <!-- /> -->
            <!-- </v-card-actions> -->
            <!-- </v-card> -->
            <!-- </v-col> -->
            <!-- </v-row> -->
        </v-form>
        <div class="header">Informations Déclaratives</div>
        <v-form>
            <v-row>
                <v-col cols="6">
                    <v-card outlined class="card">
                        <v-card-title> TVA </v-card-title>
                        <v-card-actions>
                            <v-row>
                                <v-col cols="12">
                                    <v-select-filled
                                        label="&#xca;tes-vous assujetti à la TVA ?"
                                        v-model="accounting.payedVAT"
                                        outlined
                                        hide-details
                                        :items="payedVAT"
                                        item-value="id"
                                        required
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.vatSystem"
                                        outlined
                                        hide-details
                                        label="Régime TVA"
                                        :items="vatSystems"
                                        item-value="id"
                                        required
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.vatDeclarationDay"
                                        outlined
                                        hide-details
                                        label="Jour déclaration TVA"
                                        :items="vatDeclarationDays"
                                        required
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.vatOption"
                                        outlined
                                        hide-details
                                        label="Option de TVA"
                                        :items="vatOptions"
                                        item-value="id"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    >
                                    </v-select-filled>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-card outlined class="card" style="overflow: initial; z-index: initial">
                        <v-card-title> Imposition </v-card-title>
                        <v-card-actions>
                            <v-row>
                                <v-col cols="12">
                                    <v-select-filled
                                        v-model="declaration.taxSystemType"
                                        hide-details
                                        label="Imposition"
                                        :items="taxSystemTypes"
                                        item-value="id"
                                        required
                                        :item-title="(item) => item.name"
                                        density="compact"
                                    >
                                    </v-select-filled>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete-filled
                                        :list-props="{ maxWidth: '75vw' }"
                                        v-model="declaration.sie"
                                        :items="sieList"
                                        hide-details
                                        :item-title="
                                            (x) => {
                                                return x.city
                                                    ? x.city +
                                                          ' - ' +
                                                          x.name +
                                                          ' ' +
                                                          x.postalCode +
                                                          ' ' +
                                                          x.address
                                                    : '';
                                            }
                                        "
                                        item-value="id"
                                        label="Service des impôts des entreprises"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <oss-date-picker-filled
                                        v-model="declaration.startBusinessDate"
                                        hide-details
                                        label="Date de début d'activité"
                                        style="flex: 1"
                                        :textFieldReadOnly="false"
                                    >
                                    </oss-date-picker-filled>
                                </v-col>
                                <v-col cols="6">
                                    <oss-date-picker-filled
                                        v-model="declaration.firstAccountingPeriodEnd"
                                        hide-details
                                        label="Date de fin du premier exercice"
                                        style="flex: 1"
                                        :textFieldReadOnly="false"
                                    >
                                    </oss-date-picker-filled>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script lang="ts">
import _, { orderBy } from "lodash";

import SIE_LIST from "@/graphql/company/SieList.gql";

import { CompanyVatSystem, getVATSystem } from "@/services/vat/vatHelpers.services";
import { FormSelectOption } from "@/types/formSelectOption.types";
import { Offer_type } from "@/types/offer.types";
import { accountingInfo, declarationInfo } from "@/types/registerServices.types";
import { Component, Model, Prop, Vue, Watch, toNative } from "vue-facing-decorator";
import { IncomeCategories, TaxRegimes, TaxSystemsTypes } from "../../types/tax/taxSystems.types";
import { getIncomeCategoriesByTaxRegime, getTaxRegimesByIncomeCategory } from "@/services/taxIncomeFilterServices";

@Component
export class AccountingForm extends Vue {
    @Model({ default: null, name: "data" }) readonly accounting: accountingInfo;
    @Prop({ default: null }) readonly declaration: declarationInfo;
    @Prop({ default: Offer_type.BUSINESS_BASIC }) readonly offer: Offer_type;

    sieList: any = [];

    accountingType: any = [
        { id: "RECEIVABLES_DEBT", name: "Comptabilité d'engagement" },
        { id: "INCOMING_OUTGOING_PAYMENT", name: "Comptabilité de trésorerie" },
    ];

    payedVAT: any = [
        { id: true, name: "Oui" },
        { id: false, name: "Non" },
    ];

    vatSystems: Array<FormSelectOption> = [
        { id: CompanyVatSystem.NotSubjectTo, name: getVATSystem(CompanyVatSystem.NotSubjectTo) },
        {
            id: CompanyVatSystem.BelowTheThreshold,
            name: getVATSystem(CompanyVatSystem.BelowTheThreshold),
        },
        { id: CompanyVatSystem.Normal, name: getVATSystem(CompanyVatSystem.Normal) },
        { id: CompanyVatSystem.Quartely, name: getVATSystem(CompanyVatSystem.Quartely) },
        { id: CompanyVatSystem.Simplified, name: getVATSystem(CompanyVatSystem.Simplified) },
        {
            id: CompanyVatSystem.SimplifiedExercise,
            name: getVATSystem(CompanyVatSystem.SimplifiedExercise),
        },
        {
            id: CompanyVatSystem.FlatRateRefund,
            name: getVATSystem(CompanyVatSystem.FlatRateRefund),
        },
    ];

    vatOptions: any = [
        { id: null, name: "N/C" },
        { id: "Debits", name: "Débits" },
        { id: "Receipts", name: "Encaissements" },
    ];

    vatDeclarationDays = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    taxSystemTypes: FormSelectOption[] = TaxSystemsTypes;
    allIncomeCategories: FormSelectOption[] = IncomeCategories;
    allTaxRegimes: FormSelectOption[] = TaxRegimes;

    
    async beforeMount() {
        const result = await this.$apollo.query({
            query: SIE_LIST,
        });
        this.sieList = orderBy(_.cloneDeep(result.data.getSie.sie), "postalCode");
        
        const match = TaxRegimes.find((t) => t.name === this.accounting.taxRegime);
        if (match) {
            this.accounting.taxRegime = match.id;
        }
    }
    
    @Watch("accounting.incomeCategory")
    updateAccountingType() {
        switch (this.accounting.incomeCategory) {
            case "BIC":
                this.accounting.accountingType = "RECEIVABLES_DEBT";
                break;
            case "BNC":
                this.accounting.accountingType = "INCOMING_OUTGOING_PAYMENT";
                break;
        }
    }

    get incomeCategories() {
        return getIncomeCategoriesByTaxRegime(
        this.allIncomeCategories,
        this.accounting.taxRegime
        )
    }

    get taxRegimes() {
        return getTaxRegimesByIncomeCategory(
        this.allTaxRegimes,
        this.accounting.incomeCategory
        )
    }

    @Watch('accounting.incomeCategory')
    onIncomeCategoryChange() {
        if (
        this.accounting.taxRegime &&
        !this.taxRegimes.find(tax => tax.id === this.accounting.taxRegime)
        ) {
        this.accounting.taxRegime = null
        }
    }

    @Watch('accounting.taxRegime')
    onTaxRegimeChange() {
        if (
        this.accounting.incomeCategory &&
        !this.incomeCategories.find(income => income.id === this.accounting.incomeCategory)
        ) {
        this.accounting.incomeCategory = null
        }
    }

}

export default toNative(AccountingForm);
</script>

<style scoped>
.header {
    text-align: center;
    margin-bottom: 2vh;
    font-weight: bold;
}

.card {
    border-width: 0px;
}
</style>
